'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectAuthenticated = undefined;

var _reselect = require('reselect');

var selectContext = function selectContext(state) {
    return state.context;
};

var selectAuthenticated = exports.selectAuthenticated = function selectAuthenticated() {
    return (0, _reselect.createSelector)(selectContext, function (contextState) {
        if (contextState.session && contextState.session.authenticationToken && contextState.session.authenticationToken.expires) {
            if (new Date(contextState.session.authenticationToken.expires) > new Date()) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    });
};